import React, { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import ImgInCircle from 'components/UI/ImgInCircle/ImgInCircle'
// import { LoginForm } from 'pages/auth/view/LoginForm'
import { registerUser } from 'services/endpoints/auth'

import styles from './_modal.module.scss'
// import { useAuthModalContext } from './AuthmodalContext'
import './style.css'

type InviteStep = 1 | 2 | 3

type Step1Data = {
    username: string
    email: string
    password: string
}

type SocialData = {
    instagram: string
    twitter: string
    youtube: string
    tiktok: string
}

const InvitationRequest = ({ openModal, setOpenModal }: any) => {
    const { t } = useTranslation()
    // const modelData = useAuthModalContext()

    const [step, setStep] = useState<InviteStep>(1)
    const [showPassword, setShowPassword] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isClosing, setIsClosing] = useState(false)
    const modalRef = useRef<HTMLDivElement>(null)
    const [step1Data, setStep1Data] = useState<Step1Data>({
        username: '',
        email: '',
        password: ''
    })

    const [socialData, setSocialData] = useState<SocialData>({
        instagram: '',
        twitter: '',
        youtube: '',
        tiktok: ''
    })

const closeModal = () => {
    setIsClosing(true)

    setTimeout(() => {
        setOpenModal(false)
        setStep(1)
        setShowPassword(false)
        setIsClosing(false)
    }, 150)
}

    const isForm = () => step === 1 || step === 2

    const handleOpenFromRequestButton = (e: MouseEvent) => {
        const target = e.target as Element | null

        if (target?.matches('[data-request]')) {
            setStep(1)
            setOpenModal(true)
        }
    }
useEffect(() => {
    if (!openModal) return

    const handleClickOutside = (e: MouseEvent) => {
        if (
            modalRef.current &&
            !modalRef.current.contains(e.target as Node)
        ) {
            closeModal()
        }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
        document.removeEventListener('mousedown', handleClickOutside)
    }
}, [openModal])
    useEffect(() => {
        document.addEventListener('click', handleOpenFromRequestButton)

        return () => {
            document.removeEventListener('click', handleOpenFromRequestButton)
        }
    }, [])

    if (!openModal) return null

    const handleStep1Submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setStep(2)
    }

    const handleStep2Submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (isSubmitting) return

        setIsSubmitting(true)

        try {
            await registerUser({
                name: step1Data.username,
                username: step1Data.username,
                email: step1Data.email,
                password: step1Data.password,
                password_confirmation: step1Data.password,
                is_model: 1,
                referral_code: '',
                instagram: socialData.instagram,
                twitter: socialData.twitter,
                youtube: socialData.youtube,
                tiktok: socialData.tiktok
            } as any)

            setStep(3)
        } catch (err) {
            console.error('Pre-register failed:', err)
        } finally {
            setIsSubmitting(false)
        }
    }

/*     const handleLoginClick = () => {
        closeModal()

        setTimeout(() => {
            modelData.addModal('login', <LoginForm />, true, false)
        }, 100)
    }
 */
return (
<div
    className={`${styles.modal} ${styles['modal--active']} invite-request-modal ${
        isClosing ? 'invite-request-modal--closing' : ''
    }`}
    role='dialog'
    aria-modal='true'
>
    <div
        ref={modalRef}
        className={`${styles.modal__overlay} invite-request-modal__box`}
    >
            <div className={styles.modal__overlay__ring}>
                <ImgInCircle
                    type='login'
                    customClass={`ll__logos__circle ${
                        isForm() ? 'll__logos__circle--form' : ''
                    }`}
                >
                    <img
    src='/logo.png'
    alt={t('logo')}
    style={{ width: '60px', height: '60px' }}
/>
                </ImgInCircle>
            </div>

            <div className={styles.modal__card}>
                <button
                    type='button'
                    className='invite-modal__close'
                    onClick={closeModal}
                    aria-label='Close'
                >
                    ×
                </button>

                {step === 1 && (
                    <form
                        className='invite-modal__content swal-invite-step1'
                        onSubmit={handleStep1Submit}
                    >
                            <h2 className='custom-swal-title'>
                                Pre-Register Today
                            </h2>

                            <div className='form-group'>
                                <input
                                    type='text'
                                    className='form-field'
                                    placeholder='Create Username'
                                    value={step1Data.username}
                                    onChange={e =>
                                        setStep1Data(prev => ({
                                            ...prev,
                                            username: e.target.value
                                        }))
                                    }
                                />
                                <div className='form-icons'>
                                    <span className='form-error'>Error</span>
                                </div>
                            </div>

                            <div className='form-group'>
                                <input
                                    type='email'
                                    className='form-field'
                                    placeholder='Enter Email'
                                    value={step1Data.email}
                                    onChange={e =>
                                        setStep1Data(prev => ({
                                            ...prev,
                                            email: e.target.value
                                        }))
                                    }
                                />
                                <div className='form-icons'>
                                    <span className='form-error'>Error</span>
                                </div>
                            </div>

                            <div className='form-group'>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className='form-field'
                                    placeholder='Create Password'
                                    value={step1Data.password}
                                    onChange={e =>
                                        setStep1Data(prev => ({
                                            ...prev,
                                            password: e.target.value
                                        }))
                                    }
                                />

                                <div className='form-icons'>
                                    <span className='form-error'>Error</span>

                                    <button
                                        type='button'
                                        className={`form-icon toggle-password ${
                                            showPassword ? 'active' : ''
                                        }`}
                                        onClick={() =>
                                            setShowPassword(prev => !prev)
                                        }
                                        aria-label={
                                            showPassword
                                                ? 'Hide password'
                                                : 'Show password'
                                        }
                                    >
                                        <svg
                                            id='show'
                                            width='24'
                                            height='25'
                                            viewBox='0 0 24 25'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                fillRule='evenodd'
                                                clipRule='evenodd'
                                                d='M15.1615 12.5526C15.1615 14.2986 13.7455 15.7136 11.9995 15.7136C10.2535 15.7136 8.8385 14.2986 8.8385 12.5526C8.8385 10.8056 10.2535 9.39062 11.9995 9.39062C13.7455 9.39062 15.1615 10.8056 15.1615 12.5526Z'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                fillRule='evenodd'
                                                clipRule='evenodd'
                                                d='M11.998 19.854C15.806 19.854 19.289 17.116 21.25 12.552C19.289 7.988 15.806 5.25 11.998 5.25H12.002C8.194 5.25 4.711 7.988 2.75 12.552C4.711 17.116 8.194 19.854 12.002 19.854H11.998Z'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                        </svg>

                                        <svg
                                            id='hide'
                                            width='24'
                                            height='25'
                                            viewBox='0 0 24 25'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path
                                                d='M9.76063 14.8677C9.18563 14.2937 8.83563 13.5137 8.83563 12.6387C8.83563 10.8857 10.2476 9.47266 11.9996 9.47266C12.8666 9.47266 13.6646 9.82366 14.2296 10.3977'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M15.1048 13.1992C14.8728 14.4892 13.8568 15.5072 12.5678 15.7412'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M6.65463 17.9739C5.06763 16.7279 3.72363 14.9079 2.74963 12.6389C3.73363 10.3599 5.08663 8.52994 6.68363 7.27394C8.27063 6.01794 10.1016 5.33594 11.9996 5.33594C13.9086 5.33594 15.7386 6.02794 17.3356 7.29294'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M19.4477 9.49023C20.1357 10.4042 20.7407 11.4592 21.2497 12.6362C19.2827 17.1932 15.8067 19.9382 11.9997 19.9382C11.1367 19.9382 10.2857 19.7982 9.46765 19.5252'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path
                                                d='M19.887 4.75L4.11304 20.524'
                                                stroke='#696B73'
                                                strokeWidth='1.5'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <button type='submit' className='invite-btn-primary'>
                                Continue
                            </button>
                        </form>
                    )}

                    {step === 2 && (
                        <form
                            className='invite-modal__content swal-invite-step2'
                            onSubmit={handleStep2Submit}
                        >
                            <h2 className='custom-swal-title--social'>
                                Add Your Social
                            </h2>

                            <div className='form-group field-social'>
                                <input
                                    type='text'
                                    className='form-field'
                                    placeholder='Instagram'
                                    value={socialData.instagram}
                                    onChange={e =>
                                        setSocialData(prev => ({
                                            ...prev,
                                            instagram: e.target.value
                                        }))
                                    }
                                />
                                <div className='social-icon social-icon__instagram'>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M7.16797 3.125C4.94873 3.125 3.125 4.94629 3.125 7.16797V12.832C3.125 15.0513 4.94629 16.875 7.16797 16.875H12.832C15.0513 16.875 16.875 15.0537 16.875 12.832V7.16797C16.875 4.94873 15.0537 3.125 12.832 3.125H7.16797ZM7.16797 4.375H12.832C14.3774 4.375 15.625 5.62256 15.625 7.16797V12.832C15.625 14.3774 14.3774 15.625 12.832 15.625H7.16797C5.62256 15.625 4.375 14.3774 4.375 12.832V7.16797C4.375 5.62256 5.62256 4.375 7.16797 4.375ZM13.6914 5.74219C13.3765 5.74219 13.125 5.99365 13.125 6.30859C13.125 6.62353 13.3765 6.875 13.6914 6.875C14.0063 6.875 14.2578 6.62353 14.2578 6.30859C14.2578 5.99365 14.0063 5.74219 13.6914 5.74219ZM10 6.25C7.93701 6.25 6.25 7.93701 6.25 10C6.25 12.063 7.93701 13.75 10 13.75C12.063 13.75 13.75 12.063 13.75 10C13.75 7.93701 12.063 6.25 10 6.25ZM10 7.5C11.3892 7.5 12.5 8.61084 12.5 10C12.5 11.3892 11.3892 12.5 10 12.5C8.61084 12.5 7.5 11.3892 7.5 10C7.5 8.61084 8.61084 7.5 10 7.5Z'
                                            fill='#16161C'
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className='form-group field-social'>
                                <input
                                    type='text'
                                    className='form-field'
                                    placeholder='Twitter / X'
                                    value={socialData.twitter}
                                    onChange={e =>
                                        setSocialData(prev => ({
                                            ...prev,
                                            twitter: e.target.value
                                        }))
                                    }
                                />
                                <div className='social-icon social-icon__twitter'>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M17.58 17.3327L11.7167 8.78468L11.7267 8.79268L17.0133 2.66602H15.2467L10.94 7.65268L7.52 2.66602H2.88667L8.36067 10.6467L8.36 10.646L2.58667 17.3327H4.35334L9.14134 11.7847L12.9467 17.3327H17.58ZM6.82 3.99935L15.0467 15.9993H13.6467L5.41334 3.99935H6.82Z'
                                            fill='#16161C'
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className='form-group field-social'>
                                <input
                                    type='text'
                                    className='form-field'
                                    placeholder='Youtube'
                                    value={socialData.youtube}
                                    onChange={e =>
                                        setSocialData(prev => ({
                                            ...prev,
                                            youtube: e.target.value
                                        }))
                                    }
                                />
                                <div className='social-icon social-icon__youtube'>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M9.99998 2.66602C7.20931 2.66602 3.58722 3.36523 3.58722 3.36523L3.5781 3.37565C2.30709 3.57893 1.33331 4.6711 1.33331 5.99935V9.99935V10.0007V13.9993V14.0007C1.33455 14.635 1.56189 15.2481 1.97451 15.73C2.38713 16.2118 2.958 16.5308 3.58461 16.6296L3.58722 16.6335C3.58722 16.6335 7.20931 17.334 9.99998 17.334C12.7906 17.334 16.4127 16.6335 16.4127 16.6335L16.414 16.6322C17.0413 16.5336 17.6129 16.2144 18.0258 15.732C18.4387 15.2496 18.666 14.6356 18.6666 14.0007V13.9993V10.0007V9.99935V5.99935C18.6657 5.36477 18.4385 4.75132 18.0259 4.26922C17.6132 3.78712 17.0422 3.46798 16.4153 3.36914L16.4127 3.36523C16.4127 3.36523 12.7906 2.66602 9.99998 2.66602ZM7.99998 6.93164L13.3333 9.99935L7.99998 13.0671V6.93164Z'
                                            fill='#16161C'
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className='form-group field-social'>
                                <input
                                    type='text'
                                    className='form-field'
                                    placeholder='Tiktok'
                                    value={socialData.tiktok}
                                    onChange={e =>
                                        setSocialData(prev => ({
                                            ...prev,
                                            tiktok: e.target.value
                                        }))
                                    }
                                />
                                <div className='social-icon social-icon__tiktok'>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M5 2.5C3.62919 2.5 2.5 3.62919 2.5 5V15C2.5 16.3708 3.62919 17.5 5 17.5H15C16.3708 17.5 17.5 16.3708 17.5 15V5C17.5 3.62919 16.3708 2.5 15 2.5H5ZM5 4.16667H15C15.4709 4.16667 15.8333 4.52914 15.8333 5V15C15.8333 15.4709 15.4709 15.8333 15 15.8333H5C4.52914 15.8333 4.16667 15.4709 4.16667 15V5C4.16667 4.52914 4.52914 4.16667 5 4.16667ZM10 5.83333V11.6667C10 12.1375 9.63752 12.5 9.16667 12.5C8.69581 12.5 8.33333 12.1375 8.33333 11.6667C8.33333 11.1958 8.69581 10.8333 9.16667 10.8333V9.16667C7.79586 9.16667 6.66667 10.2959 6.66667 11.6667C6.66667 13.0375 7.79586 14.1667 9.16667 14.1667C10.5375 14.1667 11.6667 13.0375 11.6667 11.6667V8.52702C12.1801 8.89278 12.7159 9.16667 13.3333 9.16667V7.5C13.2939 7.5 12.7189 7.31745 12.3177 6.96777C11.9165 6.6181 11.6667 6.17916 11.6667 5.83333H10Z'
                                            fill='#16161C'
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className='invite-modal__actions invite-modal__actions--split'>
                                <button
                                    type='submit'
                                    className='invite-btn-primary'
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>

                                <button
                                    type='button'
                                    className='invite-btn-secondary'
                                    onClick={() => setStep(1)}
                                    disabled={isSubmitting}
                                >
                                    Back
                                </button>
                            </div>
                        </form>
                    )}

                    {step === 3 && (
                        <div className='invite-modal__content swal-thank-you'>
                            <h2 className='custom-swal-title'>
                                Thank you for your interest.
                            </h2>

                            <p className='invite-modal__text'>
                                We have received your request and you will hear
                                back from us shortly.
                            </p>

                            <button
                                type='button'
                                className='invite-btn-outline'
                                onClick={closeModal}
                            >
                                Back to Homepage
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default InvitationRequest